import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getAccount } from "Redux/Actions/GetAccountAction";

import AppConstants from "Constants/AppConstants";

import { getProductFromVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import BusinessCheque from "./BusinessCheque";
import * as ROUTES from "Constants/Routes";
import withBusinessHOC from "../../Hoc/BusinessHOC";
import { HTTP_STATUS } from "../../Communication/Constants";
import {
  getApplication,
  updateApplication,
} from "../../Redux/Actions/ApplicationAction";

class BusinessChequeContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log("componentDidMount");
  }

  handleChange = () => {};

  handleContinue = (data) => {
    console.log("handleContinue", data);
    const { continuehandler, doUpdateApplication, applicantData } = this.props;
    doUpdateApplication(
      data.application.applicationId,
      data.application,
      (res) => {
        console.log(res);
        if (res.status === HTTP_STATUS.OK) {
          continuehandler(
            data.vault,
            AppConstants.APPLICATIONSTEP.BUSINESS_CHEQUE
          );
        }
      }
    );
  };

  render() {
    const {
      getDataFromServer,
      handleBack,
      steps,
      activeStepID,
      products,
      getActiveProduct,
      applicantData,
    } = this.props;
    const activeProduct = getActiveProduct(products);

    return (
      <>
        <BusinessCheque
          handleContinue={this.handleContinue}
          handleChange={this.handleChange}
          getDataFromServer={getDataFromServer}
          handleBack={handleBack}
          steps={steps}
          activeStepID={activeStepID}
          activeProduct={activeProduct}
          applicantData={applicantData}
        />
      </>
    );
  }
}

BusinessChequeContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

BusinessChequeContainer.defaultProps = {
  steps: [],
  activeStepID: -1,
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  provinceList: state.AboutYouReducer.provinceList,
  actionBack: state.ApplicationReducer.actionBack,
  streetTypes: state.LoanDetailsReducer.streetTypes,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doUpdateApplication: (applicationId, payLoad, callback) =>
      dispatch(updateApplication(applicationId, payLoad, callback)),
    doGetApplication: (request, callback) =>
      dispatch(getApplication(request, callback)),
  };
};

// export default connect(mapStateToProps, mapDispatchToProps)(BusinessChequeContainer);

const BusinessChequeWrapper = withBusinessHOC(BusinessChequeContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessChequeWrapper);
